import { apiFetch, parseJson } from "./client";
import type { Dealer } from "./types";

/** The admin keeps the catalog; the backend matches part of the name. */
export async function searchDealers(q: string): Promise<Dealer[]> {
  return parseJson<Dealer[]>(
    await apiFetch(`/api/dealers?${new URLSearchParams({ q }).toString()}`)
  );
}
